export const header = {
  navigation: {
    features: 'الميزات',
    businessTypes: 'أنواع التجارة',
    testimonials: 'الشهادات',
    contact: 'اتصل بنا',
    dashboard: 'لوحة التحكم',
    subscription: 'الاشتراك'
  },
  auth: {
    login: 'تسجيل الدخول',
    register: 'تسجيل',
    logout: 'تسجيل الخروج',
    fillForm: 'يرجى ملء النموذج أدناه',
    fullName: 'الاسم الكامل',
    fullNamePlaceholder: 'أدخل اسمك الكامل',
    phone: 'رقم الهاتف',
    phonePlaceholder: '06 XX XX XX XX',
    city: 'المدينة',
    selectCity: 'اختر مدينتك',
    businessType: 'نوع النشاط',
    selectBusinessType: 'اختر نوع نشاطك'
  },
  cities: {
    casablanca: 'الدار البيضاء',
    rabat: 'الرباط',
    marrakech: 'مراكش',
    fes: 'فاس',
    tanger: 'طنجة',
    agadir: 'أكادير',
    meknes: 'مكناس',
    oujda: 'وجدة',
    kenitra: 'القنيطرة',
    tetouan: 'تطوان',
    sale: 'سلا',
    nador: 'الناظور',
    mohammedia: 'المحمدية',
    eljadida: 'الجديدة',
    benimellal: 'بني ملال',
    other: 'أخرى'
  },
  businessTypes: {
    epicerie: 'بقالة',
    parapharmacie: 'صيدلية',
    cafe_restaurant: 'مقهى مطعم',
    boulangerie_patisserie: 'مخبز حلويات',
    meule: 'مطحنة',
    vetement: 'ملابس',
    atelier: 'ورشة',
    service_maintenance: 'خدمة صيانة'
  },
  common: {
    cancel: 'إلغاء',
    send: 'إرسال',
    sending: 'جاري الإرسال...'
  },
  mobile: {
    menu: 'فتح القائمة'
  }
}; 